import { fromFullUtc } from '@/tools/formatedate';
import { ContractsType, Contract } from '../types';

const parse = (data: Contract): Contract => ({
  ...data,
  end_date_plan: fromFullUtc(data.end_date_plan),
  start_date_plan: fromFullUtc(data.start_date_plan),
});

const parseList = (list: ContractsType): ContractsType => {
  return list.map(parse);
};

export default parseList;



// WEBPACK FOOTER //
// ./src/services/contracts/utils/parseList.ts